const rules = [
  {
    description: 'Very flammable, low bp',
    matcher: {
      hazards: ['H222', 'H224', 'H225'],
      bpLessThan: 35,
    },
    volumes: [
      {
        lessThan: 0.01,
        score: 1.5,
      },
      {
        lessThan: 0.05,
        score: 3,
      },
      {
        lessThan: 0.5,
        score: 4,
      },
      {
        lessThan: 1,
        score: 5,
      },
      {
        lessThan: +Infinity,
        score: 10,
      },
    ],
  },
  {
    description: 'Very flammable, high bp',
    matcher: {
      hazards: ['H222', 'H224', 'H225'],
    },
    volumes: [
      {
        lessThan: 0.01,
        score: 1,
      },
      {
        lessThan: 0.05,
        score: 2,
      },
      {
        lessThan: 0.5,
        score: 3,
      },
      {
        lessThan: 1,
        score: 4,
      },
      {
        lessThan: +Infinity,
        score: 8,
      },
    ],
  },
  {
    description: 'Flammable, low bp',
    matcher: {
      hazards: ['H223', 'H226', 'H227', 'H228'],
      bpLessThan: 35,
    },
    volumes: [
      {
        lessThan: 0.01,
        score: 0.5,
      },
      {
        lessThan: 0.05,
        score: 1,
      },
      {
        lessThan: 0.5,
        score: 2,
      },
      {
        lessThan: 1,
        score: 3,
      },
      {
        lessThan: +Infinity,
        score: 6,
      },
    ],
  },
  {
    description: 'Flammable, high bp',
    matcher: {
      hazards: ['H223', 'H226', 'H227', 'H228'],
    },
    volumes: [
      {
        lessThan: 0.01,
        score: 0,
      },
      {
        lessThan: 0.05,
        score: 0.5,
      },
      {
        lessThan: 0.5,
        score: 1,
      },
      {
        lessThan: 1,
        score: 2,
      },
      {
        lessThan: +Infinity,
        score: 4,
      },
    ],
  },
  {
    description: 'Not flammable',
    matcher: {},
    volumes: [
      {
        lessThan: 0.5,
        score: 0,
      },
      {
        lessThan: 1,
        score: 1,
      },
      {
        lessThan: +Infinity,
        score: 3,
      },
    ],
  },
];

export function appendVolumeAndFlammability(reagents, report, options) {
  const totalVolume = getTotalVolume(reagents, options);
  // what is the worse hazard ?
  let bestScore = 0;
  for (const rule of rules) {
    for (const reagent of reagents) {
      if (reagent.safety.volumeAndFlammability) continue;

      const matching = isMatching(reagent, rule);
      if (!matching) continue;
      const score = rule.volumes.find((volume) => totalVolume <= volume.lessThan)
        .score;
      if (score > bestScore) {
        bestScore = score;
      }
      reagent.safety.volumeAndFlammability = {
        description: rule.description,
        matchingHazards: matching.matchingHazards || [],
        score,
      };
    }
  }
  report.scores.volumeAndFlammability = bestScore
}

function isMatching(reagent, rule) {
  if (!rule.matcher.hazards) return true;
  if (!rule.matcher.bpLessThan && reagent.bp > rule.matcher.bpLessThan) {
    return false;
  }
  const matchingHazards = rule.matcher.hazards.filter((hazard) =>
    reagent.hazards.includes(hazard),
  );
  if (matchingHazards.length === 0) return false;
  return {
    matchingHazards,
  };
}

function getTotalVolume(reagents, options) {
  const { logger } = options;
  let totalVolume = 0;
  for (const reagent of reagents) {
    if (reagent.volume) {
      totalVolume += reagent.volume.value;
    } else {
      logger.warn(`reagent ${reagent.smiles} has no volume`);
      totalVolume += reagent.mass.value;
    }
  }
  return totalVolume;
}
